import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { withSpinning } from './withSpinning';

const containerRules = () => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  opacity: 1,
  zIndex: 1,
  pointerEvents: 'none',
});

const spinnerRules = () => ({
  width: '4.5em',
  height: '4.5em',
  color: '#fdfdfd',
  display: 'inline-block',
  background: 'transparent',
  extend: [
    withSpinning('750'),
  ],
});

const PlayerSpinner = ({
  extendContainer,
  extendSpinner,
  visible = true,
}) => {
  const { css } = useFela({ visible });
  return (
    <div className={css([containerRules, extendContainer])}>
      <span className={css([spinnerRules, extendSpinner])}>
        <svg
          viewBox="0 0 200 200"
          color="#fff"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="spinner-secondHalf">
              <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
              <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
            </linearGradient>
            <linearGradient id="spinner-firstHalf">
              <stop offset="20%" stopOpacity="0" stopColor="currentColor" />
              <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
            </linearGradient>
          </defs>

          <g strokeWidth="20">
            <path stroke="url(#spinner-secondHalf)" d="M 10 100 A 90 90 0 0 0 190 100" />
            <path stroke="url(#spinner-firstHalf)" d="M 190 100 A 90 90 0 0 0 10 100" />
          </g>
        </svg>
      </span>
    </div>
  );
};

PlayerSpinner.propTypes = {
  extendContainer: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  extendSpinner: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  visible: PropTypes.bool,
};

export default React.memo(PlayerSpinner);
